import __request__ from "routing/request";
export function metrics() {
  return __request__("GET", "/system/metrics", null, {}, {
    "Accept": ["application/json"]
  });
}
export function multipleMetrics(Requestedmetrics) {
  return __request__("POST", "/system/metrics/multiple", Requestedmetrics, {}, {
    "Accept": []
  });
}
export function metricNames() {
  return __request__("GET", "/system/metrics/names", null, {}, {
    "Accept": ["application/json"]
  });
}
export function byNamespace(namespace) {
  return __request__("GET", `/system/metrics/namespace/${namespace}`, null, {}, {
    "Accept": ["application/json"]
  });
}
export function singleMetric(metricName) {
  return __request__("GET", `/system/metrics/${metricName}`, null, {}, {
    "Accept": ["application/json"]
  });
}
